import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import styles from "../styles";
import { formatNumber } from "../../../../utils/common";

const DrawDetailsReferral = ({ dataLoading, referralDetails, tickerUnit }) => {
    return (
        <Container sx={{ my: 2 }}>
            <Typography sx={styles.referralLevelsTableTitleText}>
                Referral (Multi-level) Commission Chart
            </Typography>
            <TableContainer sx={styles.referralTableContainer}>
                <Table sx={{ border: "none" }}>
                    <TableHead>
                        <TableRow sx={{ border: "none" }}>
                            <TableCell align="center" sx={{ border: "none" }}>
                                <Typography sx={styles.tableReferralHeadText}>
                                    #
                                </Typography>
                            </TableCell>
                            <TableCell align="center" sx={{ border: "none" }}>
                                <Typography sx={styles.tableReferralHeadText}>
                                    Levels
                                </Typography>
                            </TableCell>
                            <TableCell align="center" sx={{ border: "none" }}>
                                <Typography sx={styles.tableReferralHeadText}>
                                    Percentage
                                </Typography>
                            </TableCell>
                            <TableCell align="center" sx={{ border: "none" }}>
                                <Typography sx={styles.tableReferralHeadText}>
                                    Commission
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataLoading ? (
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    <center>
                                        {/* <LoadingAnimationComponent /> */}
                                    </center>
                                </TableCell>
                            </TableRow>
                        ) : referralDetails && referralDetails?.length > 0 ? (
                            referralDetails.map((item, index) => (
                                <TableRow
                                    key={index}
                                    sx={{
                                        backgroundColor:
                                            index % 2 !== 0
                                                ? "rgba(242, 242, 242, 1)"
                                                : "rgba(255, 255, 255, 1)",
                                    }}
                                >
                                    <TableCell align="center" sx={{ border: "none" }}>
                                        <Typography sx={styles.tableCellText}>
                                            {index + 1}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center" sx={{ border: "none" }}>
                                        <Typography sx={styles.tableCellText}>
                                            {`Level - ${item.level
                                                .toString()
                                                .padStart(2, "0")}`}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center" sx={{ border: "none" }}>
                                        <Typography sx={styles.tableCellText}>
                                            {item.percentage}%
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center" sx={{ border: "none" }}>
                                        <Typography sx={styles.tableCellText}>
                                            {`${tickerUnit}
                                ${item.commission}`}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ))) : (
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    <Typography sx={styles.tableCellText}>
                                        No data available
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
}

export default DrawDetailsReferral;